import css from "./MeowCount.css";

export class MeowCount {
    constructor() {
        this._container = document.querySelector('#meow-count');
        this.set(0);
    }

    set(count) {
        this._container.innerHTML = '#' + count;
    }

    enableWarning() {
        this._container.className = css.warning;
    }

    enableStrongWarning() {
        this._container.className = css['strong-warning'];
    }
}
